import React, { CSSProperties, FC } from 'react'
import { Formik, FormikConfig } from 'formik'

interface FormWrapperProps<T = any> extends FormikConfig<T> {
    style?: CSSProperties
    className?: string
    formId?: string
    formName?: string
    validateOnChange?: boolean
    validateOnBlur?: boolean
}

export const FormWrapper: FC<FormWrapperProps> = ({
    children,
    style,
    formId,
    className,
    formName,
    validateOnChange = false,
    validateOnBlur = true,
    ...rest
}) => {
    return (
        <Formik validateOnChange={validateOnChange} validateOnBlur={validateOnBlur} {...rest}>
            {(formikProps) => (
                <form
                    action="#"
                    name={formName}
                    id={formId}
                    className={className}
                    style={style}
                    onSubmit={formikProps.handleSubmit}
                >
                    {typeof children === 'function' ? children(formikProps) : children}
                </form>
            )}
        </Formik>
    )
}
